import * as Highcharts from "highcharts";
import { CommonService } from "../../../services/common.service";
const commonServiceObj = new CommonService();

export const chart1 = {
  credits: { enabled: false },
  chart: { type: "column" },
  title: { text: "", align: "left" },
  xAxis: { categories: ["All"] },
  yAxis: [
    {
      min: 0,
      max: 110,
      title: { text: "Percentage" },
      stackLabels: { enabled: false },
      labels: {
        style: { fontSize: "12px" },
        format: "{value}%"
      }
    }
  ],
  legend: { enabled: true, itemMarginTop: 10, itemMarginBottom: -20 },
  marker: { enabled: false },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>"
    // pointFormat: "{series.name}: {point.y}<br/>Under Process: {point.x}"
  },
  plotOptions: {
    column: { stacking: "normal", dataLabels: { enabled: false } }
  },
  series: [
    {
      name: "Under Process",
      color: "#C6CDD4",
      data: [15],
      showInLegend: false
    },
    { name: "SLA", color: "#007FD8", data: [80], showInLegend: false }
  ]
};


export const chart2 = {
  credits: { enabled: false },
  chart: { zoomType: "xy", type: "column" },
  title: {
    text: ""
  },

  xAxis: 
    {
      categories: ["North", "South", "East", "West"],
      crosshair: true,
      labels: { style: { fontSize: "12px", color: "#626262" },
      formatter: function(){return commonServiceObj.settingFormater(this.value)} 
      },
    }
  ,
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { fontSize: "12px", color: "#626262" }
      },
      title: {
        text: "Percentage",
        style: { fontSize: "12px", color: "#626262" }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Quantity (Units)",
        style: { fontSize: "12px", color: "#626262" }
      },
      labels: {
        format: "{value}",
        style: { fontSize: "12px", color: "#626262" }
      },
      opposite: true
    }
  ],
  plotOptions: {
    line: {
      lineWidth: 2,
      dataLabels: {
        enabled: true,
        formatter: function() {
          if (this.point.x == this.series.data.length - 1) {
            return `Target (${this.y}%)`;
          }
        },
        style: {
          color: "#626262",
          fontSize: "12px",
          fontWeight: "normal"
        }
      },
      enableMouseTracking: true,
      marker: {
        enabled: false
      }
    },
    column: {
      stacking: "normal"
    }
  },
  tooltip: { shared: true },
  legend: {
    enabled: false,
    itemMarginTop: 0,
    itemMarginBottom: -20,
    align: "center",
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },

  series: [
    {
      name: "Under Process",
      data: [],
      stack: "A",
      color: "#C6CDD4",
      tooltip: { valueSuffix: "%" },
      enableMouseTracking: false
    },
    {
      name: "SLA ",
      data: [49.9, 71.5, 80.4, 92.2],
      stack: "A",
      color: "#007FD8",
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Quantity",
      data: [7.0, 6.9, 9.5, 14],
      stack: "B",
      yAxis: 1,
      color: "#909dc0",
      tooltip: { valueSuffix: " (Units)" }
    },
    {
      type: "line",
      name: "Target",
      showInLegend: false,
      data: [0, 0, 0],
      dashStyle: "ShortDash",
      color: "#979797",
      tooltip: { valueSuffix: "%" },
      enableMouseTracking: false
    }
  ]
};
